<template>
  <el-alert
    :title="title"
    :type="type"
    :closable="dismissible"
    :show-icon="showIcon"
    @close="$emit('dismiss')"
  >
    <slot />
  </el-alert>
</template>

<script>
export default {
  name: 'EcAlert',
  props: {
    title: { type: String, default: '' },
    type: { type: String, default: 'info' },
    dismissible: { type: Boolean, default: true },
    showIcon: { type: Boolean, default: true },
  },
}
</script>
